/*
 * please follow the wiki: http://wiki.corp.qunar.com/pages/viewpage.action?pageId=105923056
 * @providesModule QFontSet
 */

// 每次改完版本号之后,务必把fontFamily中引入的版本号也替换!!
// order_rn当中的src/config/fontSet/font.css也需要替换
module.exports = {
    'cmn_component_order-0_0_9': 'https://s.qunarzz.com/ppfe/cmn_component_order/fonts/0.0.9/cmn_component_order.ttf'
};
